export function isProd(): boolean {
    return /bankx\.io/.test(window.location.hostname);
}
